import { Button } from 'antd';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';

import { Input, Label } from '../../../../components/UI/Forms/Forms';
import Modal from '../../../../components/UI/Modal/Modal';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
`;

const SmallInput = styled.div`
  width: 45%;
`;

const ButtonFilled = styled(Button)`
  width: 45%;
`;

const AddJob = forwardRef(({ onSave }, ref) => {
  const [addJobIsVisible, setAddJobIsVisible] = useState(false);
  const [form, setForm] = useState({
    career_name: '',
    career_start: '',
    career_end: '',
  });

  useImperativeHandle(ref, () => ({
    showModal: () => {
      setAddJobIsVisible(true);
      setForm({
        career_name: '',
        career_start: '',
        career_end: '',
      });
    },
  }));

  const close = () => setAddJobIsVisible(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const isInvalid = !(form.career_end && form.career_start && form.career_name);

  const save = () => {
    onSave?.({
      ...form,
    });
    close();
  };

  return (
    <Modal isVisible={addJobIsVisible} title="Add Job">
      <Label>
        Company name
        <Input
          value={form.career_name}
          name="career_name"
          onChange={handleChange}
          placeholder="Enter company name"
        />
      </Label>
      <Wrapper>
        <SmallInput>
          <Label>
            <Input
              value={form.career_start}
              name="career_start"
              onChange={handleChange}
              placeholder="Year from"
            />
          </Label>
        </SmallInput>
        <SmallInput>
          <Label>
            <Input
              value={form.career_end}
              name="career_end"
              onChange={handleChange}
              placeholder="Year to"
            />
          </Label>
        </SmallInput>
      </Wrapper>
      <Wrapper>
        <ButtonFilled onClick={close}>Cancel</ButtonFilled>
        <ButtonFilled type="primary" disabled={isInvalid} onClick={save}>
          Add
        </ButtonFilled>
      </Wrapper>
    </Modal>
  );
});

export default AddJob;
